import { BaseModule } from ".";

export class StyleModule extends BaseModule {

  /**
   * @type {Number}
   */
  strokeSize = 15;

  /**
   * @type {String}
   */
  strokeColor = "rgba(0,0,0,1)";

  /**
   * @type {String}
   */
  fillColor = "rgba(0,0,0,1)";

  /**
   * Override styles.
   * @param {Object} styles New styles to override.
   */
  setStyles(styles) {
    for (const ix in styles) {
      if (Object.hasOwnProperty.call(styles, ix)) {
        const value = styles[ix];
        this[ix] = value;
      }
    }

    this.emit("change", {
      strokeSize: this.strokeSize,
      strokeColor: this.strokeColor,
      fillColor: this.fillColor
    });
  }

}